import type { ButtonVariant } from 'bootstrap-vue-next'

export interface CommonModalOptions {
  title?: string
  body?: string
  okTitle?: string
  okOnly?: boolean
  cancelTitle?: string
  autofocusButton?: ModalResult
  size?: 'sm' | 'md' | 'lg' | 'xl'
  okColor?: ButtonVariant
  centered?: boolean
}

export const MODAL_TYPE = {
  alert: 'Alert',
  confirm: 'Confirm'
} as const
export type ModalType = (typeof MODAL_TYPE)[keyof typeof MODAL_TYPE]

export const MODAL_RESULT = {
  OK: 'ok',
  CANCEL: 'cancel',
  CLOSE: 'close'
} as const
export type ModalResult = (typeof MODAL_RESULT)[keyof typeof MODAL_RESULT]
